import React, { memo } from 'react';

const Wallet = memo(({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8847 4H5.11526C3.39475 4 2 5.4423 2 7.22148V16.7785C2 18.5577 3.39475 20 5.11526 20H18.8847C20.6052 20 22 18.5577 22 16.7785V7.22148C22 5.4423 20.6052 4 18.8847 4Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1016 9.60571H21.9894V14.395H16.1016C15.2397 14.395 14.5439 13.6755 14.5439 12.7842V11.2165C14.5439 10.3252 15.2397 9.60571 16.1016 9.60571Z"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8291 12.0001H18.2725"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default Wallet;
